module.exports = __webpack_public_path__ + "static/media/new-metronome.ab18046d.wav";